import React from "react";
import { Box, Typography, Card, Button, IconButton } from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import ImageSlider from "./ImageSlider";

export default function BlogCard({ post, canEdit, onEdit, onDelete, onReadMore, onImageClick, themeConfig }) {
  return (
    <Box style={{ marginBottom: "18px" }}>
      <Card elevation={0} style={{ backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
        <Box style={{ padding: "12px 18px 8px 18px", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <Typography
            variant="h6"
            onClick={onReadMore}
            style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 800, fontSize: "1.15rem", lineHeight: 1.3, color: "#1a1a1a", cursor: "pointer", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}
          >
            {post.title}
          </Typography>
          {canEdit && (
            <Box display="flex" gap={0.5}>
              <IconButton size="small" onClick={() => onEdit(post)}><EditIcon fontSize="small" /></IconButton>
              <IconButton size="small" color="error" onClick={() => onDelete(post.id)}><DeleteIcon fontSize="small" /></IconButton>
            </Box>
          )}
        </Box>

        {post.images && post.images.length > 0 && (
          <ImageSlider
            images={post.images}
            alt={post.title}
            height="210px"
            onImageClick={(idx) => onImageClick(post.images, idx, post.title)}
          />
        )}

        <Box style={{ padding: "8px 18px 12px 18px" }}>
          <Typography
            variant="body2"
            style={{ fontFamily: "'Raleway', sans-serif", fontSize: "0.88rem", lineHeight: 1.45, color: "#444444", textAlign: "justify", display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden" }}
          >
            <span style={{ fontWeight: 700, color: "#666", marginRight: "6px" }}>
              {new Date(post.created_on).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })} —
            </span>
            {post.snippet || post.content}
          </Typography>
          <Box display="flex" justifyContent="flex-end" mt={1}>
            <Button size="small" onClick={onReadMore} style={{ color: themeConfig.buttonColor, textTransform: "none", fontWeight: 700, fontFamily: "'Raleway', sans-serif", padding: 0 }}>
              Read more →
            </Button>
          </Box>
        </Box>
      </Card>
    </Box>
  );
}
